import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCoverageWidgetSetupDataThunk } from "./getCoverageWidgetSetupDataThunk";
import { setWidgetSetup } from "../../../dashboardsSlice";
import { coverageWidgetSetupDefaultData } from "../../../utils/constants/coverageWidgetSetupDefaultData";
import { RootState } from "@/store/store";
import { getOrganizationsForCommitmentsThunk } from "@/store/commitments/thunks/getOrganizationsForCommitmentsThunk";
import { commitmentsOrganizationsSelector } from "@/store/commitments/selectors/organisations/commitmentsOrganizationsSelector";
import { CommitmentCloudProvider } from "@/services/cloudchipr.api";

export const initiateCoverageWidgetThunk = createAsyncThunk(
  "dashboard/initiateCoverageWidget",
  async (enableAzure: boolean, { dispatch, getState }) => {
    const state = getState() as RootState;

    await dispatch(getOrganizationsForCommitmentsThunk());

    const organizations = commitmentsOrganizationsSelector(state, enableAzure);
    const firstOrgWithSavingsPlan = organizations?.find(
      (org) => org.has_savings_plan,
    );

    dispatch(
      setWidgetSetup({
        ...coverageWidgetSetupDefaultData,
        providerOrganisationId:
          firstOrgWithSavingsPlan?.organization_id ?? undefined,
        provider: (firstOrgWithSavingsPlan?.cloud_provider ??
          "aws") as CommitmentCloudProvider,
      }),
    );

    dispatch(getCoverageWidgetSetupDataThunk());
  },
);
